import { Action } from 'redux'

import actionTypes from 'common/actions/constants/ReduxActionTypes'
import {
  IActionField,
  SelectedActionSource,
} from 'common/actions/integrations/Applications/interfaces'
import { getActionFields } from 'common/actions/integrations/Applications/selectors/integrationsApplicationsSelectors'
import { IThunkAction } from 'common/core/interfaces/actions'
import { ApplicationsApi } from 'shared/api/requests/applications'
import { createAsyncAction } from 'shared/lib/redux'

export const fetchApplicationsTriggers = createAsyncAction(
  'integration/accountApps/fetchApplicationsTriggers',
  async () => {
    const response = await ApplicationsApi.fetchAppTriggers()
    return response.data
  },
)

export const fetchApplicationActions = createAsyncAction(
  'integration/accountApps/fetchApplicationActions',
  async (applicationId: number) => {
    const response = await ApplicationsApi.getAppActions({
      query: { app_id: applicationId },
    })
    return response.data
  },
)

export const fetchApplicationAction = createAsyncAction(
  'integration/accountApps/fetchApplicationAction',
  async ({ applicationId, actionName }: { applicationId: number; actionName: string }) => {
    const response = await ApplicationsApi.getAppAction({
      query: { app_id: applicationId, action_name: actionName },
    })
    return response.data
  },
)

export const fetchApplicationSource = createAsyncAction(
  'integration/accountApps/fetchApplicationSource',
  async ({
    applicationId,
    sourceName,
    group,
  }: {
    applicationId: number
    sourceName: string
    group?: string | number
  }) => {
    const response = await ApplicationsApi.loadAppSource({
      query: {
        app_id: applicationId,
        source_name: sourceName,
        group,
      },
    })
    return response.data
  },
)

export const resetApplicationSources = () => ({
  type: actionTypes.APPLICATION_ACTION_SOURCES_RESET,
})

export const selectApplication = ({
  _oid,
  applicationId,
  actionName,
  source,
}: {
  _oid: string
  applicationId: number
  actionName?: string
  source: SelectedActionSource
}) => ({
  type: actionTypes.APPLICATION_ACTION_SELECT_APPLICATION,
  _oid,
  applicationId,
  actionName,
  selectedActionSource: source,
})

export const deselectApplicationAction = (): Action => ({
  type: actionTypes.APPLICATION_DESELECT_ACTION,
})

export const deselectApplication = (): Action => ({
  type: actionTypes.APPLICATION_ACTION_DESELECT_APPLICATION,
})

export const updateField = (field: IActionField) => ({
  type: actionTypes.APPLICATION_ACTION_FIELD_UPDATE,
  fields: [field],
  mapping: [],
})

export const updateMapping = (field: IActionField) => ({
  type: actionTypes.APPLICATION_ACTION_FIELD_UPDATE,
  fields: [],
  mapping: [field],
})

export const setFields = (fields: IActionField[], mapping: IActionField[]) => ({
  type: actionTypes.APPLICATION_ACTION_FIELDS_SET,
  fields,
  mapping,
})

export const validateFields = (): IThunkAction<boolean> => (dispatch, getState) => {
  dispatch({
    type: actionTypes.APPLICATION_ACTION_FIELDS_VALIDATE,
  })

  const fields = getActionFields(getState())

  return !fields.filter((el) => !el.isValid).length
}

export const validateField = (fieldName: string) => ({
  type: actionTypes.APPLICATION_ACTION_FIELD_VALIDATE,
  fieldName,
})
